import { Box, IconButton } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../constants/colors';

export const Container = styled(Box)`
  && {
    cursor: pointer;
    flex-grow: 1;
    border: 1px solid ${colors.lightGray};
    padding: 40px;
    display: flex;
    flex-direction: column;
  }
`;

export const Name = styled.p`
  margin-top: 20px;
  color: ${colors.mediumGray};
`;

export const ButtonIconStyled = styled(IconButton)`
  && {
    border: 0;
    outline: 0;
    text-decoration: none;
  }
`;

export const paperMenuStyle = {
  elevation: 0,
  sx: {
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 1.5,
    '& .MuiAvatar-root': {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1
    },
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0
    }
  }
};
